import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_discount';

/**
 * Retrieves a discount.
 * @deprecated It has been replaced with com.wix.ecom.discounts.DiscountRuleService.GetDiscountRule(), and will be removed on 2025-09-30.
 */
export function getDiscount(payload: object): RequestOptionsFactory<any> {
  function __getDiscount({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.discount',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DiscountsApi.GetDiscount',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/discounts/{discountId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getDiscount;
}

/**
 * Updates a discount.
 * A discount can belong to a catalog, section, or dish. You can't create a discount that applies to a menu.
 * @deprecated It has been replaced with com.wix.ecom.discounts.DiscountRuleService.UpdateDiscountRule(), and will be removed on 2025-09-30.
 */
export function updateDiscount(payload: object): RequestOptionsFactory<any> {
  function __updateDiscount({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.discount',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DiscountsApi.UpdateDiscount',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/discounts/{discount.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateDiscount;
}

/**
 * Creates a discount.
 * You can create discounts for catalogs, sections, or dishes. You can't create a discount that applies to a menu.
 * @deprecated It has been replaced with com.wix.ecom.discounts.DiscountRuleService.CreateDiscountRule(), and will be removed on 2025-09-30.
 */
export function createDiscount(payload: object): RequestOptionsFactory<any> {
  function __createDiscount({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.discount',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DiscountsApi.CreateDiscount',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/discounts',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createDiscount;
}

/**
 * Retrieves up to 1000 discounts.
 * @deprecated It has been replaced with com.wix.ecom.discounts.DiscountRuleService.QueryDiscountRules(), and will be removed on 2025-09-30.
 */
export function listDiscounts(payload: object): RequestOptionsFactory<any> {
  function __listDiscounts({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.discount',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DiscountsApi.ListDiscounts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/discounts',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
    };

    return metadata;
  }

  return __listDiscounts;
}
